import React, { useState } from 'react';
import EditorPaquetes from '../../components/EditorPaquetes';

export default function Paso2Servicios({ datos, onChange, onSiguiente, onAnterior }) {
  const [paquetes, setPaquetes] = useState(datos.paquetes || []);

  const total = paquetes.reduce((a, p) => a + (parseFloat(p.precio) || 0), 0);

  const handleSiguiente = () => {
    const paquetesLimpios = paquetes.map(p => ({
      ...p,
      tareas: p.tareas.filter(t => t.descripcion.trim()),
      repuestos: p.repuestos.filter(r => r.nombre.trim()).map(r => ({
        ...r, costo_taller: parseFloat(r.costo_taller) || 0
      })),
    }));
    onChange({ paquetes: paquetesLimpios });
    onSiguiente();
  };

  return (
    <div>
      <div className="sec-header">
        <h2 className="sec-title">Servicios</h2>
      </div>

      <EditorPaquetes paquetes={paquetes} setPaquetes={setPaquetes} vehiculo={datos.vehiculo} />

      {total > 0 && (
        <div style={{
          background: 'var(--azul)', color: 'white',
          borderRadius: 'var(--radio)', padding: '.75rem 1.25rem',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: '1rem', fontWeight: 600, fontSize: '1.05rem'
        }}>
          <span>TOTAL ESTIMADO</span>
          <span>${total.toLocaleString('es-UY', { maximumFractionDigits: 0 })}</span>
        </div>
      )}

      <div style={{ display: 'flex', gap: '.5rem' }}>
        <button className="btn btn-secondary" onClick={onAnterior}>← Atrás</button>
        <button className="btn btn-primary" style={{ flex: 1 }}
          disabled={paquetes.length === 0} onClick={handleSiguiente}>
          Continuar → Crear orden
        </button>
      </div>
    </div>
  );
}
